import React, {FC} from 'react';

import {
  BoxedInput,
  BoxedInputInheritableProps,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {MarkdownEditorProps} from '../editor/markdown/markdownEditor';
import {BoxedMarkdownEditor} from './boxedMarkdownEditor';

/*
 * Props.
 */

export type MarkdownEditorBoxProps = MarkdownEditorProps & BoxedInputInheritableProps;

/*
 * Component.
 */

export const MarkdownEditorBox: FC<MarkdownEditorBoxProps> = (props) => (
  <BoxedInput {...props}>{(childProps) => <BoxedMarkdownEditor {...childProps} {...props} />}</BoxedInput>
);
